import { defineStore } from "pinia";
import type { User } from "@/types";
import client from "@/utils/axios";

export const useUserStore = defineStore("user", {
  state: (): User => ({
    fullName: "",
    email: "",
    statusFilters: [],
    filter: "",
    searchFilter: "",
    viewOptions: [],
    nameFilter: [],
    lastLogin: "",
    accessToken: "",
    refreshToken: "",
    avatar: "",
    language: "en",
    adminTranslations: [],
    translationsUpdateTimestamp: 0,
  }),

  getters: {
    getUser: (state) => {
      return {
        fullName: state.fullName,
        email: state.email,
        lastLogin: state.lastLogin,
      };
    },
    getAccessToken: (state) => state.accessToken,
    getRefreshToken: (state) => state.refreshToken,
    getAdminTranslations: (state) => state.adminTranslations,
    getCurrentLanguage: (state) => state.language,
    getAvatar: (state) => state.avatar,
  },

  actions: {
    async setTokens(accessToken: any, refreshToken: any) {
      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
    },
    async setUser(
      name?: string,
      email?: string,
      statusFilters?: Array<string>,
      filter?: string,
      searchFilter?: string,
      viewOptions?: Array<string>,
      nameFilter?: Array<string>,
      lang?: string,
      imageUrl?: string
    ) {
      this.fullName = name ? name : "";
      this.email = email ? email : "";
      this.statusFilters = statusFilters ? statusFilters : [];
      this.filter = filter ? filter : "";
      this.searchFilter = searchFilter ? searchFilter : "";
      this.viewOptions = viewOptions ? viewOptions : [];
      this.nameFilter = nameFilter ? nameFilter : [];
      this.language = lang ? lang : "en";
      this.avatar = imageUrl ? imageUrl : "";
    },
    setStatusFilters(statusFilters: Array<string>) {
      this.statusFilters = statusFilters;
    },
    setFilter(filter: string) {
      this.filter = filter;
    },
    setSearchFilter(searchFilter: string) {
      this.searchFilter = searchFilter;
    },
    setViewOption(viewOptions: Array<string>) {
      this.viewOptions = viewOptions;
    },
    setNameFilter(nameFilter: Array<string>) {
      this.nameFilter = nameFilter;
    },
    setLanguage(language: "en" | "de") {
      this.language = language;
    },
    setAdminTranslation(adminTranslations: Array<string>) {
      this.adminTranslations = adminTranslations;
    },
    setDatabaseTranslationsUpdateTimestamp() {
      this.translationsUpdateTimestamp = new Date().getTime();
    },
    async changeLanguage(language: "en" | "de") {
      this.language = language;
      await client.put("/language/" + language);
    },
    logout() {
      this.fullName = "";
      this.email = "";
      this.lastLogin = "";
      this.accessToken = "";
      this.refreshToken = "";
      this.statusFilters = [];
      this.filter = "";
      this.searchFilter = "";
      this.viewOptions = [];
      this.nameFilter = [];
      this.language = "";
    },
  },
  persist: true,
});
